import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasSmartResizeMenuOpened.meta';

export type UseTrackCanvasSmartResizeMenuOpenedParams = {
  canvas_id: string;
  node_type: 'image' | 'video';
};

export const useTrackCanvasSmartResizeMenuOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasSmartResizeMenuOpened = useCallback(
    (params: UseTrackCanvasSmartResizeMenuOpenedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasSmartResizeMenuOpened };
};
